<template>
  <div class="group-and-person-workbench" v-loading="loading">
    <!-- 顶部导航 -->
    <div class="workbench-header">
      <div class="content-area workbench-header-content">
        <el-button class="back-btn" icon="el-icon-arrow-left" @click="goBackHandle">返回</el-button>
        <span class="header-title-wrap" @click="openSwitchModalHandle">
          <span class="header-title">{{ activeTitle }}</span>
          <i class="el-icon-arrow-down switch-icon"></i>
        </span>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="workbench-content">
      <div class="content-area">
        <!-- 目标列表 -->
        <GoalCardListInfo
          :currentMonth="currentMonth"
          :goalList="goalList"
          :groupInfoId="activeGroupInfoId"
          :workNumber="activeWorkNumber"
          @changeMonth="changeMonthHandle"
          @cardClick="cardClickHandle"
          @yearGoalClick="yearGoalClickHandle"
        />

        <!-- 小组成员完成情况 -->
        <TeamGoalFinishInfo
          v-if="isGroupWorkbench"
          :teamData="teamData"
          :teamColumns="teamColumns"
          @teamClick="memberClickHandle"
        />
 
        <!-- 线索列表 -->
        <ClueListInfo
          ref="clueListInfoRef"
          :showTeamCol="false"
          :showFollowerCol="isGroupWorkbench"
          :showAddClueBtn="false"
          :groupInfoId="activeGroupInfoId"
          :workNumber="activeWorkNumber"
          @nameClick="nameClickHandle"
          @followerClick="followerClickHandle"
        />
 
        <!-- 拜访次数统计 -->
        <VisitNumInfo
          ref="visitNumInfoRef"
          :groupInfoId="activeGroupInfoId"
          :workNumber="activeWorkNumber"
          :showFollowerCol="isGroupWorkbench"
          @nameClick="nameClickHandle"
        />

      </div>

      <!-- 全屏弹窗遮罩层 -->
      <div v-if="modalInfo.showFullScreenModal" class="back-drop">
        <!-- 小组/个人工作台 -->
        <GroupAndPersonWorkbench
          ref="GroupAndPersonWorkbenchRef"
          v-if="modalInfo.showFullScreenModal"
          :month="currentMonth"
          :groupType="currentTeamInfo.groupType"
          :groupInfoId="currentTeamInfo.groupInfoId"
          :workNumber="currentTeamInfo.workNumber"
          :teamList="teamList"
          :memberList="teamData"
          :title="activeTitle + '-' + currentTeamInfo.followerWorkName"
          @back="goBackSecondHandle"
          @cardClick="cardClickHandle"
          @nameClick="nameClickHandle"
        />
      </div>
      <!-- 本年目标详情弹窗 -->
      <CustomModal
        v-model="modalInfo.showYearGoalDetailModal"
        title="本年目标"
        width="870px"
        :showSubmitBtn="false"
        cancelBtnText="关闭"
        :modalContentNoPadding="true"
        @cancelHandle="modalInfo.showYearGoalDetailModal = false"
      >
        <YearGoalDetail
          v-if="modalInfo.showYearGoalDetailModal"
          ref="yearGoalDetailRef"
          :showStaffList="!activeWorkNumber"
          :groupInfoId="activeGroupInfoId"
          :workNumber="activeWorkNumber"
        />
      </CustomModal>

      <!-- 切换小组/引进员弹窗 -->
      <CustomModal
        v-model="switchInfo.visible"
        :title="isGroupWorkbench ? '请选择组' : '请选择引进员'"
        width="360px"
        :showSubmitBtn="true"
        submitBtnText="确定"
        cancelBtnText="取消"
        @submitHandle="switchConfirmHandle"
        @cancelHandle="switchInfo.visible = false"
      >
        <div class="switch-form">
          <span class="switch-label">请选择</span>
          <el-select
            v-model="switchInfo.selectedValue"
            placeholder="请选择"
            size="small"
            filterable
            :loading="switchInfo.loading"
            class="switch-select"
          >
            <el-option
              v-for="item in switchInfo.optionList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </CustomModal>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
const goalList = [
  { type: 'month', tag: '月度', name: '3星医生20名', finishTargetNumber: 0, targetNumber: 0, percentage: 0 },
  { type: 'quarter', tag: '季度', name: '4星医生16名', finishTargetNumber: 0, targetNumber: 0, percentage: 0 },
  { type: 'year', tag: '年度', name: '5星医生8名', finishTargetNumber: 0, targetNumber: 0, percentage: 0 }
]
export default {
  name: 'GroupAndPersonWorkbench',
  props: {
    title: {
      type: String,
      default: ''
    },
    month: {
      type: [String, Number],
      default: new Date().getMonth() + 1
    },
    groupType: {
      type: Number,
      default: 0
    },
    groupInfoId: {
      type: [String, Number],
      default: ''
    },
    workNumber: {
      type: [String, Number],
      default: ''
    },
    // 团队完成情况表格数据（用于「请选择组」弹窗选项）
    teamList: {
      type: Array,
      default: () => []
    },
    // 成员完成情况表格数据（用于「请选择引进员」弹窗选项）
    memberList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      currentMonth: new Date().getMonth() + 1,
      currentGoalDetail: { // 当前目标详情参数
        period: '',
        month: '',
        saleStar: ''
      },
      goalList: [],
      // 团队目标列配置
      teamColumns: [
        { label: '团队', prop: 'teamName', minWidth: '120', align: 'left', slotName: 'teamCell' },
        { label: '3月完成情况', prop: 'monthCell', minWidth: '180', align: 'left', slotName: 'monthCell' },
        { label: '第1季度完成情况', prop: 'quarterCell', minWidth: '180', align: 'left', slotName: 'quarterCell' },
        { label: '本年度完成情况', prop: 'yearCell', minWidth: '180', align: 'left', slotName: 'yearCell' }
      ],
      teamData: [],
      modalInfo: {
        // 全屏弹窗
        showFullScreenModal: false,
        // 本年目标详情弹窗
        showYearGoalDetailModal: false,
      },
      currentTeamInfo: {}, // 当前操作的团队信息
      // 切换小组/引进员弹窗
      switchInfo: {
        visible: false,
        loading: false,
        optionList: [],
        selectedValue: ''
      },
      // 切换后的覆盖信息（为空时使用 props 传入的数据范围）
      overrideInfo: null
    }
  },
  computed: {
    // 是否小组工作台（groupType 为 1 表示小组，其余视为成员）
    isGroupWorkbench() {
      return Number(this.activeGroupType) === 1
    },
    // 当前生效的数据范围
    activeGroupType() {
      return this.overrideInfo ? this.overrideInfo.groupType : this.groupType
    },
    activeGroupInfoId() {
      return this.overrideInfo ? this.overrideInfo.groupInfoId : this.groupInfoId
    },
    activeWorkNumber() {
      return this.overrideInfo ? this.overrideInfo.workNumber : this.workNumber
    },
    activeTitle() {
      return this.overrideInfo ? this.overrideInfo.title : this.title
    }
  },
  watch: {
    // 外部数据范围变化时，清除内部切换状态，避免数据串台
    groupInfoId() {
      this.resetOverrideInfo()
    },
    workNumber() {
      this.resetOverrideInfo()
    },
    groupType() {
      this.resetOverrideInfo()
    }
  },
  methods: {
    changeMonthHandle(month) {
      this.currentMonth = month
      this.getGoalData()
    },

    // 获取目标数据
    async getGoalData() {
      const params = {
        month: this.currentMonth,
        quarter: Math.floor((this.currentMonth - 1) / 3) + 1,
        year: new Date().getFullYear(),
        ...this.activeGroupInfoId && {
          groupInfoId: this.activeGroupInfoId || ''
        },
        ...this.activeWorkNumber && {
          workNumber: this.activeWorkNumber || ''
        }
      }
      this.loading = true
      try {
        const res = await request.get('/cluepool/pc/admin/dashboard/target/detail', params, '')
        if (res.code === 200) {
          this.getGoalCardData(res.data || {})
          this.getTeamData(res.data || {})
        }
      } catch (error) {
        console.error('获取数据失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 处理目标数据
    getGoalCardData (data = {}) {
      const info = {
        month: 'monthTargetStartInfo',
        quarter: 'quarterTargetStartInfo',
        year: 'yearTargetStartInfo'
      }
      this.goalList = goalList.map(item => {
        const currentItemList = data[info[item.type]] || []
        if (currentItemList.length > 0) {
          return currentItemList.map(ite => {
            return {
              ...item,
              ...ite,
              name: (ite.saleStar || 0) + '星医生' + (ite.targetNumber || 0) + '名',
              finishTargetNumber: ite.finishTargetNumber || 0,
              targetNumber: ite.targetNumber || 0,
              percentage: Math.min(100, ((ite.finishTargetNumber || 0) / (ite.targetNumber || 1)) * 100)
            }
          })
        } else {
          return []
        }
      }).flat().filter(item => item.targetNumber > 0)
    },

    // 处理团队数据
    getTeamData (data = {}) {
      this.teamColumns = (this.teamColumns || []).map(item => {
        switch (item.prop) {
          case 'teamName':
            item.label = this.roleType === 1 ? '团队名称' : '成员'
            break
          case 'monthCell':
            item.label = this.currentMonth + '月完成情况'
            break
          case 'quarterCell':
            item.label = '第' + Math.floor((this.currentMonth - 1) / 3 + 1) + '季度完成情况'
            break
          default:
            break
        }
        return item
      })
      this.teamData = this.parseTeamData(data)
    },

    // 解析「团队/成员完成情况」数据为表格行（供表格与切换弹窗共用）
    parseTeamData (data = {}) {
      const key = 'groupName'
      const teamInfo = {}
      if (data.monthTargetCompleteInfo) {
        data.monthTargetCompleteInfo.forEach(el => {
          if (!teamInfo[el[key]]) {
            teamInfo[el[key]] = {}
          }
          teamInfo[el[key]] = {
            ...teamInfo[el[key]],
            monthInfo: el
          }
        })
      }
      if (data.quarterTargetCompleteInfo) {
        data.quarterTargetCompleteInfo.forEach(el => {
          if (!teamInfo[el[key]]) {
            teamInfo[el[key]] = {}
          }
          teamInfo[el[key]] = {
            ...teamInfo[el[key]],
            quarterInfo: el
          }
        })
      }
      if (data.yearTargetCompleteInfo) {
        data.yearTargetCompleteInfo.forEach(el => {
          if (!teamInfo[el[key]]) {
            teamInfo[el[key]] = {}
          }
          teamInfo[el[key]] = {
            ...teamInfo[el[key]],
            yearInfo: el
          }
        })
      }
      const teamData = []
      for (const groupName in teamInfo) {
        const info = teamInfo[groupName] || {}
        const targetInfo = info.monthInfo || info.quarterInfo || info.yearInfo || {}
        teamData.push({
          groupName,
          teamName: groupName,
          groupType: targetInfo.groupType || '',
          groupInfoId: targetInfo.groupInfoId || '',
          workNumber: targetInfo.workNumber || '',
          monthInfo: this.hasTargetStar(info.monthInfo || {}),
          quarterInfo: this.hasTargetStar(info.quarterInfo || {}),
          yearInfo: this.hasTargetStar(info.yearInfo || {})
        })
      }
      return teamData
    },

    // 判断是否有目标(星级任务是否为0，如果为0，则不显示目标，如果有多个目标，则仅显示目标的数量大于0的目标，如果所有目标都是0，则均不显示）)
    hasTargetStar(info = {}) {
      if (Object.keys(info).length === 0) return null

      const starList = info.starList || []
      const resultStarList = starList.filter(item => item.targetNumber > 0)

      if (resultStarList.length === 0) return null
      return {
        ...info,
        starList: resultStarList
      }
    },

    goBackHandle() {
      this.$emit('back')
    },

    goBackSecondHandle() {
      this.modalInfo.showFullScreenModal = false
    },

    cardClickHandle(itemInfo) {
      this.$emit('cardClick', {
        ...itemInfo,
        ...this.activeGroupInfoId && {
          groupInfoId: this.activeGroupInfoId || ''
        },
        ...this.activeWorkNumber && {
          workNumber: this.activeWorkNumber || ''
        }
      })
    },

    yearGoalClickHandle() {
      this.modalInfo.showYearGoalDetailModal = true
    },

    memberClickHandle(row) {
      // 小组信息中展示的小组成员信息
      row.followerWorkName = row.teamName || ''
      this.followerClickHandle(row)
    },

    nameClickHandle(row) {
      this.$emit('nameClick', row)
    },

    followerClickHandle(row) {
      this.currentTeamInfo = row
      this.modalInfo.showFullScreenModal = true
    },

    // 打开切换小组/引进员弹窗
    async openSwitchModalHandle() {
      this.switchInfo.selectedValue = ''
      this.switchInfo.optionList = []
      this.switchInfo.visible = true
      if (this.isGroupWorkbench) {
        this.getGroupOptions()
      } else {
        this.switchInfo.loading = true
        try {
          await this.getMemberOptions()
        } finally {
          this.switchInfo.loading = false
        }
      }
      // 默认选中当前的小组/成员
      const currentValue = this.isGroupWorkbench ? this.activeGroupInfoId : this.activeWorkNumber
      const matched = this.switchInfo.optionList.find(item => String(item.value) === String(currentValue))
      this.switchInfo.selectedValue = matched ? matched.value : ''
    },

    // 是否包含工号（用于区分「小组行」与「成员行」）
    hasWorkNumber(item = {}) {
      return item.workNumber !== '' && item.workNumber !== null && item.workNumber !== undefined
    },

    // 表格行 -> 小组选项
    toGroupOptions(list = []) {
      return (list || [])
        .filter(item => item.groupInfoId !== '' && item.groupInfoId !== null && item.groupInfoId !== undefined)
        .map(item => ({
          label: item.groupName || item.teamName || '',
          value: item.groupInfoId,
          groupName: item.groupName || item.teamName || ''
        }))
    },

    // 表格行 -> 成员选项
    toMemberOptions(list = []) {
      return (list || []).map(item => {
        const memberName = item.teamName || item.groupName || ''
        return {
          label: memberName,
          value: item.workNumber,
          nickName: memberName
        }
      })
    },

    // 小组下拉选项：取自父组件的「团队完成情况」表格数据
    getGroupOptions() {
      this.switchInfo.optionList = this.toGroupOptions(this.teamList)
    },

    // 成员下拉选项：优先取父级「成员完成情况」表格数据，无可用数据时按当前小组 id 拉取同源数据
    async getMemberOptions() {
      // 有工号且非小组行，才算有效成员数据
      const localList = (this.memberList || []).filter(item => this.hasWorkNumber(item) && Number(item.groupType) !== 1)
      if (localList.length > 0) {
        this.switchInfo.optionList = this.toMemberOptions(localList)
        return
      }
      const remoteList = await this.getGroupMemberList()
      this.switchInfo.optionList = this.toMemberOptions(remoteList)
    },

    // 按当前小组 id 获取小组成员（与「成员完成情况」表格同源：目标完成详情接口）
    async getGroupMemberList() {
      const groupInfoId = this.activeGroupInfoId
      // 无小组 id 时退回当前组件已有的表格数据
      if (!groupInfoId) {
        return (this.teamData || []).filter(item => this.hasWorkNumber(item))
      }
      const params = {
        month: this.currentMonth,
        quarter: Math.floor((this.currentMonth - 1) / 3) + 1,
        year: new Date().getFullYear(),
        groupInfoId
      }
      try {
        const res = await request.get('/cluepool/pc/admin/dashboard/target/detail', params, '')
        if (res.code === 200) {
          return this.parseTeamData(res.data || {}).filter(item => this.hasWorkNumber(item))
        }
      } catch (error) {
        console.log('获取小组成员失败', error)
      }
      return []
    },

    // 确认切换
    switchConfirmHandle() {
      const { selectedValue, optionList } = this.switchInfo
      if (!selectedValue) {
        this.$message.warning(this.isGroupWorkbench ? '请选择小组' : '请选择引进员')
        return
      }
      const option = (optionList || []).find(item => String(item.value) === String(selectedValue))
      if (!option) return

      if (this.isGroupWorkbench) {
        // 小组工作台：只切换小组
        this.overrideInfo = {
          groupType: 1,
          groupInfoId: option.value,
          workNumber: '',
          title: option.groupName || option.label
        }
      } else {
        // 成员工作台：在所属小组内切换成员
        this.overrideInfo = {
          groupType: this.activeGroupType,
          groupInfoId: this.activeGroupInfoId,
          workNumber: option.value,
          title: option.label
        }
      }
      this.switchInfo.visible = false
      this.refreshAllDataHandle()
    },

    // 清除内部切换状态
    resetOverrideInfo() {
      this.overrideInfo = null
    },

    // 切换数据范围后刷新全部子模块数据
    refreshAllDataHandle() {
      this.getGoalData()
      // 等待子组件 props 更新完成后再触发重新请求
      this.$nextTick(() => {
        if (this.$refs.clueListInfoRef) {
          this.$refs.clueListInfoRef.pageInfo.pageNum = 1
          this.$refs.clueListInfoRef.getClueList()
        }
        if (this.$refs.visitNumInfoRef) {
          this.$refs.visitNumInfoRef.pageInfo.pageNum = 1
          this.$refs.visitNumInfoRef.getTableData()
        }
      })
    },

    // 供父组件调用：刷新内部 ClueListInfo 列表数据（含嵌套子级递归）
    refreshClueList() {
      if (this.$refs.clueListInfoRef && this.$refs.clueListInfoRef.getClueList) {
        this.$refs.clueListInfoRef.getClueList()
      }
      // 若嵌套的子级 GroupAndPersonWorkbench（全屏弹窗）已打开，同步向下递归刷新
      if (this.$refs.GroupAndPersonWorkbenchRef && this.$refs.GroupAndPersonWorkbenchRef.refreshClueList) {
        this.$refs.GroupAndPersonWorkbenchRef.refreshClueList()
      }
    },
  },
  mounted() {
    this.currentMonth = this.month || new Date().getMonth() + 1
    this.getGoalData()
  },
  components: {
    GoalCardListInfo: () => import('./GoalCardListInfo.vue'),
    TeamGoalFinishInfo: () => import('./TeamGoalFinishInfo.vue'),
    ClueListInfo: () => import('./ClueListInfo.vue'),
    VisitNumInfo: () => import('./VisitNumInfo.vue'),
    CustomModal: () => import('@/views/DoctorVisitLTC/components/customModal/Custom_Modal.vue'),
    GroupAndPersonWorkbench: () => import('@/views/DoctorVisitLTC/views/workbench/components/GroupAndPersonWorkbench.vue'),
    YearGoalDetail: () => import('@/views/DoctorVisitLTC/views/workbench/components/modal/YearGoalDetail.vue')
  }
}
</script>

<style scoped lang="less">
.group-and-person-workbench {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  .content-area {
    width: 100%;
    height: 100%;
    max-width: 1300px;
    margin: 0 auto;
  }

  .workbench-header {
    width: 100%;
    border-bottom: 1px solid #E8E8E8;

    .workbench-header-content {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      height: 48px;
      background: #fff;
  
      .back-btn {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        border-color: #E0E0E0;
        color: #667182;
        font-size: 14px;
        padding: 8px 16px;
  
        &:hover {
          color: #1890FF;
          border-color: #1890FF;
        }
  
        /deep/ i {
          font-size: 14px;
          margin-right: 4px;
        }
      }
  
      .header-title-wrap {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        user-select: none;

        .header-title {
          font-size: 16px;
          font-weight: 600;
          color: #1F2329;
        }

        .switch-icon {
          font-size: 14px;
          color: #1F2329;
        }
      }
    }
  }

  .workbench-content {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
  
  // 全屏弹窗遮罩层
  .back-drop {
    position: fixed;
    top: 48px;
    left: 0;
    width: 100%;
    height: calc(100% - 48px);
    background: #FFF;
    z-index: 999;
  }
}

// 切换小组/引进员弹窗（弹窗挂载到 body，需放在顶层）
.switch-form {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 20px;

  .switch-label {
    flex-shrink: 0;
    font-size: 14px;
    color: #1F2329;
  }

  .switch-select {
    flex: 1;
    min-width: 0;

    /deep/ .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
